import { t } from '../../locales/translate';
import { formatPercentage } from '../../util/formatters';
import './ScannerLoader.css';
import React from 'react';

export function ScannerLoader({ loadedCount, totalCount }: { loadedCount: number; totalCount: number }): JSX.Element {
  const validTotalCount = !isNaN(totalCount) && totalCount !== 0;
  const loadingPercentage = validTotalCount ? loadedCount / totalCount : 0;

  return (
    <div className="scanner-loader">
      <ul className="scanner-loader__bars">
        <li className="scanner-loader__bar" />
        <li className="scanner-loader__bar" />
        <li className="scanner-loader__bar" />
        <li className="scanner-loader__bar" />
        <li className="scanner-loader__bar" />
        <li className="scanner-loader__bar" />
      </ul>
      <p className="scanner-loader__percentage">{formatPercentage(loadingPercentage, { maximumFractionDigits: 0 })}</p>
      <p className="scanner-loader__text">{t.page.ticketScanner.loadingText}</p>
    </div>
  );
}
